import styled from 'styled-components';
import { compose, margin, system, textAlign } from 'styled-system';
import { theme } from '../../essentials/theme';
import { get } from '../../utils/themeGet';
export const DEFAULT_HEADLINE_SIZE = {
    h1: 'xxl',
    h2: 'xl',
    h3: 'l',
    h4: 'm',
    h5: 's',
    h6: 'xs'
};
const parser = system({
    fontSize: {
        property: 'fontSize',
        defaultScale: {
            xs: '0.75rem',
            s: '0.875rem',
            m: '1rem',
            l: '1.5rem',
            xl: '2rem',
            xxl: '3rem'
        }
    },
    lh: {
        property: 'lineHeight',
        defaultScale: {
            xs: '1.125rem',
            s: '1.25rem',
            m: '1.375rem',
            l: '2rem',
            xl: '2.5rem',
            xxl: '3.75rem'
        }
    }
});
const getSize = ({ as = 'h1', size }) => size || DEFAULT_HEADLINE_SIZE[as];
const Headline = styled.h1.attrs({ theme }).withConfig({ displayName: "Headline", componentId: "sc-bbxrex" }) `
    color: inherit;
    font-family: ${get('fonts.normal')};
    font-weight: ${get('fontWeights.bold')};
    margin: 0;

    ${props => parser(Object.assign({ fontSize: getSize(props), lh: getSize(props) }, props))}
    ${compose(margin, textAlign)}
`;
export { Headline };
